module.exports = __webpack_public_path__ + "static/img/references7.c330a25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/references7.jpg
// module id = 8NPt
// module chunks = 1